<div id="coupon" class="ya-typography" (swiperight)="navigateBack()">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="coupon-detail-image-wrapper">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="couponViewModel.image_photo" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="coupon-detail-wrapper">
        <section class="coupon-detail-content">
          <div class="coupon-detail-page-content-header ya-detail-page-header">
            <div id="headerTitleContainer" class="coupon-detail-title">
              <h2 id="headerTitle">{{couponViewModel.label}}</h2>
            </div>
            <div class="coupon-detail-like">
              <ya-favoritebutton [contentType]="contentType.Coupon" [likeStatus]="couponViewModel.like"
                [modelId]="couponViewModel.id">
              </ya-favoritebutton>
            </div>
          </div>
          <p [innerHTML]="couponViewModel.text"> </p>
          <div class="actions">
            <div class="coupon-detail-ranking-bar">
              <bar-rating [(rate)]="couponViewModel.rate" [max]="5" [readOnly]="true"
                [theme]="'fontawesome-o'"></bar-rating>
              <div class="rate-click-div" (click)="openRateModel(couponViewModel)"></div>
            </div>
          </div>
          <div class="coupon-detail-date-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-events"></div>
            <div class="container coupon-detail-date-wrapper">
              <div class="container-border">
                <div class="coupon-detail-date top">
                  <span class="description" langkey="phEventDetail_From"></span>
                  <span>
                    {{couponViewModel.startDate}}
                  </span>
                </div>
              </div>
              <div class="coupon-detail-date bottom">
                <span class="description" langkey="phEventDetail_To"></span>
                <span>
                  {{couponViewModel.endDate}}
                </span>
              </div>
            </div>
          </div>
          <ng-container
            *ngIf="couponViewModel.anonym_code; then freeCouponTemplate else nonFreeCouponTemplate"></ng-container>
          <ng-template #freeCouponTemplate>
            <div class="container coupon-dialog">
              <div class="ya-button-group-wrapper">
                <div class="ya-button-group-container">
                  <ng-container *ngIf="useCouponCode">
                    <div class="ya-button-container">
                      <button mat-flat-button class="coupon-button"
                        (click)="couponFilterLocationIds.length>0? redeemCoupon(): ''">
                        <span langkey="phCoupon_Redeem_Now"></span>
                      </button>
                    </div>
                  </ng-container>
                  <div class="ya-button-container">
                    <button mat-flat-button class="coupon-button" (click)="openQRCodeModel(couponViewModel)">
                      <span langkey="phCoupon_Show_Code"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template #nonFreeCouponTemplate>
            <ng-container *ngIf="isLogin; then memberTemplate else nonMemberTemplate"></ng-container>
            <ng-template #memberTemplate>
              <div class="container coupon-dialog">
                <div class="ya-button-group-wrapper">
                  <div class="ya-button-group-container">
                    <ng-container *ngIf="useCouponCode">
                      <div class="ya-button-container">
                        <button mat-flat-button class="coupon-button"
                          [class.coupon-detail-btn--disabled]="isRedeemButtonDimmed"
                          (click)="couponFilterLocationIds.length>0? redeemCoupon(): ''">
                          <span langkey="phCoupon_Redeem_Now"></span>
                        </button>
                      </div>
                    </ng-container>
                    <div class="ya-button-container">
                      <button mat-flat-button class="coupon-button" (click)="openQRCodeModel(couponViewModel)">
                        <span langkey="phCoupon_Show_Code"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template #nonMemberTemplate>
              <div class="container coupon-dialog">
                <div class="ya-webshop-button-container ">
                  <h2>
                    {{dialogTitle}}
                  </h2>
                  <div class="ya-dialog-content">
                    <p>
                      {{dialogContent}}
                    </p>
                  </div>
                  <div class="ya-dialog-action">
                    <div class="ya-button-group-wrapper">
                      <div class="ya-button-group-container">
                        <div class="ya-button-container">
                          <button mat-flat-button (click)="navigateToRegister()"><span
                              langkey="phLoginDialog_Register"></span></button>
                        </div>
                        <div class="ya-button-container">
                          <button mat-stroked-button (click)="navigateToLogin()"><span
                              langkey="phLoginDialog_Login"></span></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </section>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>